{
  "about": {
    "title": "Acerca de Spring Boot Admin",
    "label": "Acerca de SBA"
  }
}
